export function restoreStore<T>(key: string, version: number, initial: T) {
  try {
    const data = localStorage.getItem(key)
    if (!data) {
      return initial
    }
    const json = JSON.parse(data)
    if (json.storageVersion !== version) {
      localStorage.removeItem(key)
      return initial
    }
    return json as T
  } catch {
    return initial
  }
}

export function persistStore<T>(key: string, state: T) {
  try {
    const data = JSON.stringify(state)
    localStorage.setItem(key, data)
  } catch {
    // NOOP: Do nothing serverside
  }
}
